import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import AutoComplete from '@mui/material/Autocomplete';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import moment from 'moment';

function AmazonUploadForm(props) {

    const [cleared, setCleared] = useState(false);

    useEffect(() => {
        if (cleared) {
        const timeout = setTimeout(() => {
            setCleared(false);
        }, 1500);

        return () => clearTimeout(timeout);
        }
        return () => {};
    }, [cleared]);

     return(
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} display = "flex" flexDirection = "column">
            <Stack direction = "row" alignItems = {"center"}>
                <FormControl sx = {{ mr: '10px', width: '20%' }}>
                    <LocalizationProvider dateAdapter = {AdapterMoment}>
                        <DesktopDatePicker
                            label = "Date"
                            name = 'startDate'
                            onChange = {(event) => props.handleDateChange(event, 'startDate')}
                            value = {props.startDate ? moment(props.startDate) : moment()}
                            renderInput = {(params) => <TextField {...params} />}
                            slotProps = {{
                                field: { clearable: true, onClear: () => setCleared(true) },
                              }}
                        />
                    </LocalizationProvider>
                </FormControl>
            </Stack>   
            {   <Stack direction = "row" alignItems = {"center"} sx = {{mt: '20px'}}>
                        <Button sx = {{ml: '10px'}} onClick = {() => props.getAmazonUploads()} disabled = {props.isLoading} variant = "contained" color = "success" >Get Days Uploads</Button> 
                    </Stack>
            }
      </Box>
    );
  };

export default AmazonUploadForm;